import React, { useMemo, useState } from 'react';

import { useForm, FormProvider } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  TransactionExportFormContext,
  transactionExportFormStateDefault,
  TransactionExportFormState,
  transactionExportSchemaDefault,
} from '@Forms/transactions/TransactionExportFormContext';

export const TransactionExportFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<TransactionExportFormState>>>(
    transactionExportSchemaDefault
  );
  const methods = useForm<TransactionExportFormState>({
    defaultValues: transactionExportFormStateDefault,
    resolver: yupResolver(schema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, methods]);

  return (
    <TransactionExportFormContext.Provider value={value}>
      <FormProvider {...methods}>{children}</FormProvider>
    </TransactionExportFormContext.Provider>
  );
};
